import React from 'react';
import { LoginHead } from './styled';

function LoginHeading(props) {
  return (
    <>
      <LoginHead>Log In</LoginHead>
    </>
  );
}

export default LoginHeading;
